import React, { FC } from 'react'
import { PromoProps } from '../../../Promo/src/Promo.types'
import { ImageCompound } from '../../../Compounds/src/ImageCompound'
import { VideoCompound } from '../../../Compounds/src/VideoCompound'
import { RTECompound } from '../../../Compounds/src/RTECompound'
import { getValueListBgColor } from '../../../../utils/background-util'

export const PromoCard: FC<PromoProps> = props => {
  const { testId, content } = props

  if (!content) {
    return null
  }

  const {
    imageLocation,
    eyebrowImage,
    icon,
    image,
    eyebrowText,
    contentText,
    video,
    backgroundColor,
    columnSize,
    brandExtension,
  } = content

  const bgColor = backgroundColor ? `${getValueListBgColor(backgroundColor)}` : ''
  const colSize = columnSize ? `u-size${columnSize}` : ''
  const centerMargin = !eyebrowImage?.src && !icon?.iconsDropdown ? 'contentMargin' : ''
  const getMediaContent = () => {
    if (video?.playlistId?.length) {
      return <VideoCompound {...video} />
    } else {
      return <ImageCompound {...image} />
    }
  }

  return (
    <div className={`${colSize} ${brandExtension}`}>
      <div
        className={`PromoCard ${bgColor} u-flex u-md-flex u-md-flexCol u-md-flexColReverse u-sm-flex u-sm-flexCol u-sm-flexColReverse ${
          imageLocation === 'left' ? 'u-flexRowReverse' : 'u-flexRow'
        }`}
      >
        <div
          className={`first-column u-size6of12 u-md-sizeFull u-sm-sizeFull u-paddingHoriz24 u-md-paddingHoriz0 u-sm-paddingHoriz0 u-md-paddingTop32 u-sm-paddingTop32 ${centerMargin} u-flex u-flexAlignItemsCenter`}
          data-testid={testId ? `${testId}-left-column` : null}
        >
          {eyebrowText && eyebrowText?.length > 0 && (
            <div className='u-paddingVert8 u-textBold'>{eyebrowText}</div>
          )}
          {contentText?.content && (
            <div>
              <RTECompound {...contentText} />
            </div>
          )}
        </div>
        <div
          className='second-column u-lg-flex u-size6of12 u-md-sizeFull u-sm-sizeFull'
          data-testid={testId ? `${testId}-right-column` : null}
        >
          {getMediaContent()}
        </div>
      </div>
    </div>
  )
}
